import type { ProgramDetail } from '../api/useProgram';
import { Section, KeyValueGrid } from './DetailSection';
import { formatDate } from '../lib/date';

const pct = (n: number) => `${+(n * 100).toFixed(2)}%`;

export const ProgramProfile = ({ program }: { program: ProgramDetail }) => {
  return (
    <Section title="Profile">
      <KeyValueGrid
        items={[
          { label: 'Name', value: program.name },
          { label: 'Tagline', value: program.tag_line || '—' },
          { label: 'Start date', value: formatDate(program.starts_at) },
          { label: 'End date', value: formatDate(program.ends_at) },
          { label: 'Access model', value: <span className="capitalize">{program.access_models.join(', ') || '—'}</span> },
          { label: 'Revenue share', value: pct(program.revenue_share) },
          { label: 'Fee', value: pct(program.fee) },
        ]}
      />
    </Section>
  );
};
